import { render, staticRenderFns } from "./ConsentLetterDetailPage.vue?vue&type=template&id=0acc254c&scoped=true"
import script from "./ConsentLetterDetailPage.vue?vue&type=script&lang=js"
export * from "./ConsentLetterDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ConsentLetterDetailPage.vue?vue&type=style&index=0&id=0acc254c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acc254c",
  null
  
)

export default component.exports